export { default as Root } from "./Root";
export { default as NotFound } from "./NotFound";
export { default as Home } from "./Home";
export { default as Product } from "./Product/Product";
export { default as ProductDetail } from "./Product/ProductDetail";
export { default as Service } from "./Service";
export { default as TipsTrends } from "./TipsTrends";
export { default as TipsTrendsDetail } from "./TipsTrendsDetail";
export { default as About } from "./About";
export { default as Faq } from "./Faq";
export { default as Contact } from "./Contact";



// WEBPACK FOOTER //
// ./src/pages/index.js